import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
// import ChatBot from 'react-simple-chatbot';
import kareem from "assets/icon/kareem-icon.svg";
import kareemwhite from "assets/icon/kareem-white-icon.svg";
import close from "assets/icon/close-icon.svg";
import kareempurple from "assets/icon/kareem-purple-icon.svg";
import claire from "assets/icon/claire-icon.svg";
import clairebot from "assets/icon/claire-bot-icon.svg";
import usericon from "assets/icon/ai-user-icon.svg";
import uparrow from "assets/icon/uparrow-icon.svg";
import leftarrow from "assets/icon/left-arrow.svg";
import newicon from "assets/icon/new-icon.svg";
import thumbsdown from "assets/icon/Thumbsdown-Selected.svg";
import thumbsup from "assets/icon/Thumbsup-Selected.svg";
import closepurple from "assets/icon/close-purple-icon.svg";
import infoicon from "assets/icon/info-icon.svg";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import useContextService from "hooks/useContextService";
import { dateOnly } from "utils/columns";
import moment from "moment";
import leftsemiCircle from "assets/icon/Left.svg";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ChatbotSearch from "./ChatbotSearch";
import Send from "assets/icon/Send.svg";
import { set } from "lodash";
import Loader from "components/Loader";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import CancelIcon from 'assets/icon/cancel.svg';
import KareemWhite from 'assets/icon/kareem-white-icon.svg';
import copyIcon from 'assets/icon/Copy.svg';

const initialMsg = [
  {
    message: "Hello, I'm Claire, your AI assistant. How can I help you?",
    isAgent: false,
  },
];
let hideloading = true;
const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
const ChatBotPage = (props) => {
  let isLastItem = "";
  const {
    showchat,
    setShowChat,
    isRendered,
    isTogglingPosition,
    setIsRendered,
    setIsTogglingPosition,
    onClick,
    chatbotOpen,
    setChatbotOpen,
    addClass,
    setAddClass,
    showChatboat,
    setShowSearch,
    showSearch,
    setIsSideChatbotOpen,
    setSideExpand,
    selectedOrg,
    orgData
  } = props;

  const [initMsg, setInitMsg] = useState(initialMsg);

  const [showBack, setShowBack] = useState(false);

  const [showchat1, setShowChat1] = useState(false);
  const [shownewChat, setNewChat] = useState(true);
  const [showChatHistory, setShowChatHistory] = useState(false);
  const [showInput, setShowInput] = useState(true);
  const [getChathistory, setGetChatHistory] = useState([]);
  const [chatList, setChatList] = useState([]);
  const [Chatname, setChatName] = useState("");
  const [feedmsg, setFeedmsg] = useState("");
  const [handleDownClickcontent, sethandleDownClickcontent] = useState(false);
  const [reportmesg, setReportMesg] = useState("");
  const [buttonclcik, setButtonClick] = useState(false);
  const [buttonclcikId, setButtonClickId] = useState([]);
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [selectedButtonNames, setSelectedButtonNames] = useState([]);
  const [load, setLoad] = useState(false);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const sliderRef = useRef(null);
  const [lines, setLines] = useState(0);
  const [timeZone, setTimeZone] = useState("");
  // const [isRendered, setIsRendered] = useState(false);
  const [isLeft, setIsLeft] = useState(false);
  // const [isTogglingPosition, setIsTogglingPosition] = useState(false);
  const [visibleText, setVisibleText] = useState('');
  const [chatNameHeader, setChatNameHeader] = useState(null);
  const textareaRef = useRef(null);
  const [height, setHeight] = useState(40);
  const [showInfo, setShowInfo] = useState(false)
  const [userDate, setUserDate] = useState([]);
  const [displayChatHistory, setdisplayChatHistory] = useState([])
  const [feeddown, setfeedDown] = useState(null)
  const [Loading, setLoading] = useState(false)
  const [copy, setCopy] = useState(false)
  const [copyIndex, setCopyIndex] = useState(null)
  const [copyText, setCopyText] = useState('')
  const copyRef = useRef([])



  // const now = new Date();
  // const formattedTime = now.toLocaleTimeString('en-US', {
  //   hour: 'numeric',
  //   minute: 'numeric',
  //   hour12: true,
  // });


  const displaybuttons = [
    { id: "Irrelevant", name: "Irrelevant" },
    { id: "Not Factually correct", name: "Not Factually correct" },
    { id: "Incomplete response", name: "Incomplete response" },
    { id: "Confusing or Unclear", name: "Confusing or Unclear" },
    { id: "Poor style", name: "Poor style" },
    {
      id: "Refused when it shouldn't have",
      name: "Refused when it shouldn't have",
    },
  ];
  const buttonnames = [
    { name: "How do I map an unmapped charge code?", id: 1 },
    { name: "What happens when I hide an NDC?", id: 2 },
    { name: "Why is my accumulation balance negative?", id: 3 },
    { name: "How does the split optimizer handle price ties?", id: 4 },
    { name: "How do I read a Drug Spend by Account report?", id: 5 },
  ];
  // const buttonnames = [
  //   { name: "How Do I Create A New Audit?", id: 1 },
  //   { name: "How Do I Make Bulk Changes To My Prescriber List?", id: 2 },
  //   { name: "How Do I View Claims Associated With My Orders?", id: 3 },
  //   { name: "What Effect Do New Orders Have On My Accumulations?", id: 4 },
  // ];
  const API = useAxios();
  const activeId = "KA2";
  const { states, resetStates } = useContextService();
  const { loading } = states;

  // useEffect(() => {
  //   if (setIsSideChatbotOpen) {
  //     setIsSideChatbotOpen(chatbotOpen);
  //   }
  // }, [chatbotOpen, setIsSideChatbotOpen]);

  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(tz);
  }, []);
  useEffect(() => {
    handelClcikChat();
  }, [showchat]);
  const handelClcikChat = () => {
    setButtonClick(false);
    sethandleDownClickcontent(false);
    setSelectedButtons([]);
    onclick;
  };

  const GetHistory = async (item) => {
    setLoading(true)

    try {
      let msg = new FormData();
      msg.append("chat_name", item);

      // const { data } = await API.post(`/get_history_new/${activeId}`, msg, {
      //   haschatApiurl: true,
      // });
      let tenantID = ''
      if (orgData.length == 1) {
        tenantID = orgData[0].tenantID
      }
      else {
        if (selectedOrg.tenantID !== undefined) {
          tenantID = selectedOrg.tenantID
        }
      }

      const { data } = await API.get(`/tenants/${tenantID}/threads`, {
        haschatApiurl: true,
      });

      if (data) {
        setChatName(data?.chat_name);
        setChatNameHeader(data.map((item) => item.thread_id));
        
        setdisplayChatHistory(data.map((item) => item.messages))
        let dateLabel = "Today"
        if (data.map((item) => item.messages.length) > 0) {
          setNewChat(false)
          setShowChatHistory(true)
          let categorizedChats = [];

          const findOrCreateDateEntry = (dateLabel) => {
            let entry = categorizedChats.find(
              (item) =>
                // item.date === dateLabel
                item.date === "Today"
            );
            if (!entry) {
              entry = { date: dateLabel, history: [] };
              categorizedChats.push(entry);
            }
            return entry;
          };

          data.forEach((item1) => {
            
            for (var x in item1.messages) {
              var item = {};
              item.isAgent = item1.messages[x].role == "user" ? true : false
              item.message = item1.messages[x].content;
              item.isRes = true;
              // categorizedChats.push(item);
              findOrCreateDateEntry(dateLabel).history.push(item)
            }
          })

          //   item = {};
          //   item.isAgent = false;
          //   item.message = chat.answer;
          //   item.msg_time = chat.msg_time;
          //   findOrCreateDateEntry(dateLabel).history.push(item);
          // });



          setChatList(categorizedChats);
          setLoading(false)
        }
        else {
          setChatList([]);
          setLoading(false)
          setNewChat(true);
        }
        setReportMesg("");
        setFeedmsg("");
        setButtonClick(false);
        setButtonClickId("");
        if (handleDownClickcontent == true) {
          handleDownClick();
        }
      }
      else {
        setChatList([]);
        setLoading(false)
      }
    } catch (error) {
      setChatList([]);
      setLoading(false)
    }
  };

  console.log(chatList, "list")
  useEffect(() => {
    if (Chatname) {
      ShowChatHistoryDetails(Chatname);
      // GetHistory(Chatname);
    }
  }, [Chatname]);

  const GetChats = async (chatNameHeader) => {
    let msg = new FormData();
    msg.append("chat_name", chatNameHeader);
    const { data } = await API.post(`/get_chats_new/${activeId}`, msg, {
      haschatApiurl: true,
    });
    if (data) {
      setGetChatHistory(data.chats);
    }
  };
  // useEffect(() => {
  //   GetChats();
  // }, []);
  // useEffect(() => {
  //   if (chatNameHeader) {
  //     GetChats(chatNameHeader);
  //   }
  // }, [chatNameHeader]);

  // const onClick = () => {
  //   if (!showchat) {
  //     setIsRendered(true);
  //     setTimeout(() => {
  //       setShowChat(true);
  //       setIsTogglingPosition(false);
  //     }, 0);
  //   } else {
  //     setShowChat(false);
  //     setIsTogglingPosition(false);
  //     setTimeout(() => {
  //       setIsRendered(false);
  //     }, 400);
  //   }
  //   // setShowChat((pre) => !pre);
  //   // setNewChat(true);
  //   // setShowChatHistory(false);
  //   // setChatName("");
  //   // setShowBack(false);
  //   setButtonClick(false);
  //   sethandleDownClickcontent(false);
  //   setSelectedButtons([]);
  //   // setShowInput(true);
  //   // setChatList([]);
  // };
  const onClick2 = () => {
    setShowChat1((pre) => !pre);
  };
  const ShowChatHistoryList = (chatNameHeader) => {
    setShowBack(true);
    setNewChat(false);
    setShowChatHistory(false);
    setChatName("");
    setShowInput(false);
    //GetChats(chatNameHeader);
  };

  const togglePosition = () => {
    // setShowSearch(true);
    if (showchat) {
      setIsTogglingPosition(true);
      setIsLeft((prev) => !prev);
    } else {
      setIsLeft((prev) => !prev);
    }
  };

  const ShowNewChat = () => {
    setNewChat(true);
    setShowBack(false);
    setShowChatHistory(false);
    setShowInput(true);
    setChatName("");
    setSelectedButtons([]);
    setChatList([]);
  };
  const ShowChatHistoryDetails = (item) => {
    setShowChatHistory(true);
    setShowBack(false);
    setNewChat(false);
    setShowInput(true);
    // GetHistory(item);
  };
  const handelClick = (event) => {
    const text = event.target.value;
    setFeedmsg(text);
  };
  const handelClickButton = (text) => {
    setFeedmsg(text);
  };

  const handelSubmit = async () => {
    if (load) return;
    // e.preventDefalut();
    if (feedmsg === "") {
      return;
    }
    if (Chatname == "") {
      setChatList([]);
      setShowChatHistory(false);
      setNewChat(false);
    }
    setLoad(true);
    setShowChatHistory(true);

    let datelabel = "Today";
    // const today = new Date();
    // const yesterday = new Date();
    // yesterday.setDate(today.getDate() - 1);

    // const formatDate = (date) => date.toISOString().split("T")[0]; // Extract YYYY-MM-DD
    // const todayFormattedDate = formatDate(today);
    // const yesterdayFormattedDate = formatDate(yesterday);


    const now = new Date();
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    var item = {
      isAgent: true,
      message: feedmsg,
      msg_time: datelabel,
      //usermsg_date: formattedTime
    };


    const findOrCreateDateEntry = (dateLabel) => {
      let entry = chatList.find((item) => item.date === datelabel);
      if (!entry) {
        entry = { date: dateLabel, history: [] };
        chatList.push(entry);
      }
      return entry;
    };

    // let msgDate = formatDate(new Date(item.msg_time));
    let dateLabel = "Today";

    const dateEntry = findOrCreateDateEntry(dateLabel);
    dateEntry.history.push(item);


    // const finalRes = {
    //   isAgent: false,
    //   message: "",
    //   msg_time: "Today",
    // };
    // dateEntry.history.push(finalRes);
    setChatList([...chatList]);
    setFeedmsg("");
    setNewChat(false);

    try {
      // let msg = new FormData();
      // msg.append("user_message", feedmsg);
      // msg.append("chat_name", Chatname ? Chatname : "");
      let streamedText = '';
      let finalRes = {
        isAgent: false,
        message: "",
        msg_time: "Today",
        isRes: false,
      };

      let playload = {
        message: feedmsg
      }
      // const response = await API.post(`/chat/stream_response/${activeId}`, msg, {
      //   responseType: 'text',
      //   haschatApiurl: true,
      // });
      const config = {
        responseType: 'text',
        haschatApiurl: true,
        onDownloadProgress: (e) => {
          const chunk = e.currentTarget.response;
          const newChunk = chunk.substring(streamedText.length);
          if (!newChunk) return;
          streamedText += newChunk;
          finalRes.message = streamedText;

          const messageIndex = dateEntry.history.findIndex(
            (msg) => msg === finalRes
          );
          if (messageIndex === -1) {
            dateEntry.history.push(finalRes);
          }
          setChatList([...chatList]);
          setLoad(false);
        }
      };
      if (displayChatHistory.length > 0) {
        config.headers = {
          "x-session-id": chatNameHeader,
        };
      }
      let tenantID = ''
      if (orgData.length == 1) {
        tenantID = orgData[0].tenantID
      }
      else {
        if (selectedOrg.tenantID !== undefined) {
          tenantID = selectedOrg.tenantID
        }
      }


      await API.post(`/tenants/${tenantID}/chat`, playload, config);
      finalRes.isRes = true;
      // const finalRes = {
      //   message: "",
      //   isAgent: false
      // };
      // finalRes.message = streamedText;

      // const response = await API.post('/chat', playload, config)
      // // setChatNameHeader(response.headers['x-session-id'])
      // const allLines = response.data.split('\n');
      // let accumulatedText = '';
      // const streamLineByLine = (index) => {
      //   if (index >= allLines.length) return;
      //   const nextChunk = allLines.slice(index, index + 5).join('\n');
      //   accumulatedText += (accumulatedText ? '\n' : '') + nextChunk;
      //   setVisibleText(accumulatedText);
      //   finalRes.message = accumulatedText
      //   setTimeout(() =>


      //     streamLineByLine(index + 5), 300

      //   );
      // };

      // streamLineByLine(0);

      //   if (data) {
      //     var res = {
      //       isAgent: false,
      //       message: data.reply_message,
      //       msg_time: data.msg_time,
      //     };

      //     // msgDate = formatDate(new Date(res.msg_time));
      //     dateLabel = "Today";

      //     findOrCreateDateEntry(dateLabel).history.push(res);

      //     setChatList([...chatList]);
      //     setChatName(data.chat_name);
      //     setFeedmsg("");
      //     setLoad(false);
      //     setMessageIndex(0);
      //   } else {
      //     setFeedmsg("");
      //     setLoad(false);
      //     setMessageIndex(0);
      //   }
      // } catch (error) {
      //   setFeedmsg("");
      //   setLoad(false);
      //   setMessageIndex(0);
      // }
      // if (displayChatHistory.length == 0) {
      //   chatList[1]?.history.push(finalRes)
      // }
      // else {
      //   chatList.map(((item) => item.history.push(finalRes)));
      // }
      // // chatList.history.push(finalRes)
      // setChatList([...chatList]);
      hideloading = true;
      setQuery("");
      setQuestions([]);
      setIsQuestionHidden(true);
      reloadChat();
    } catch (error) {
      setFeedmsg("");
      setLoad(false);
      setMessageIndex(0);
    }

  };

  // useEffect(() => {
  //   if (chatList.length == 0) {
  //     setNewChat(true)
  //   }

  // }, [chatList])

  console.log(shownewChat)

  const handelDisplay = (name, id) => {
    if (selectedButtons.includes(id)) {
      setSelectedButtons(selectedButtons.filter((buttonId) => buttonId !== id));
      setSelectedButtonNames(
        selectedButtonNames.filter((buttonName) => buttonName !== name)
      );
    } else {
      setSelectedButtons([...selectedButtons, id]);
      setSelectedButtonNames([...selectedButtonNames, name]);
    }

    // const updatedText = feedmsg + (feedmsg ? ' ' : '') + name;
    // setFeedmsg(updatedText);
  };
  const handelClickReport = (event) => {
    const text = event.target.value;
    setReportMesg(text);

    const tempElement = document.createElement("div");
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.whiteSpace = "pre-wrap";
    tempElement.style.width = event.target.offsetWidth + "px";
    tempElement.style.font = window.getComputedStyle(event.target).font;
    tempElement.textContent = text;

    document.body.appendChild(tempElement);
    const lineHeight = parseInt(
      window.getComputedStyle(event.target).lineHeight
    );
    const linesvalue = Math.ceil(tempElement.offsetHeight / lineHeight);
    setLines(linesvalue >= 3 ? linesvalue * 10 : 40);
    document.body.removeChild(tempElement);
  };
  const handleCancel = () => {
    setfeedDown(null)
    sethandleDownClickcontent(false);
  };

  const handleUpDownClick = async (message, val, question) => {
    setLoading(true)
    let buttonTextString = ''
    buttonTextString = handleDownClickcontent ? selectedButtonNames?.map((item) => item).join(",") : " ";
    const concatenatedText = reportmesg + "," + buttonTextString;
    if (concatenatedText) {
      try {
        // let msg = new FormData();
        let msg = {
          // chat_response: message,
          // feedback: val,
          // feedback_msg: concatenatedText
          "flag": val,
          "message": concatenatedText,
          "prompt": question,
          "response": message
        }
        // msg.append("chat_response", message);
        // msg.append("feedback", val);
        // msg.append("feedback_msg", concatenatedText);
        // msg.append("chat_name", chatName);
        const { data } = await API.post('api/feedback/add', msg, {
          haschatfeedbackApiurl: true,
        });
        if (data == true) {
          toast.success("Your Feedback Message has been Recorded Successfully");
          setSelectedButtons([]);

        } else {
          toast.error(data.reply_message);

        }
        setLoading(false)
        setfeedDown(null)
      } catch (error) { setLoading(false) }
    }
  };
  // const handelButtonList =(item) => {
  //   handelClickButton(item);

  //   handelSubmit();
  // };
  const handleDownClick = (message, val, chatName) => {
    sethandleDownClickcontent(!handleDownClickcontent);
    setSelectedButtonNames([])


  };


  const handleDownClickdata = (message, val, chatName, index) => {
    setfeedDown(feeddown === index ? null : index);

    handleDownClick(index);
    setReportMesg("");
    setButtonClick(false);
    setButtonClickId("");

  };
  const start = (e) => {
    setIsDown(true);
    const slider = sliderRef.current;
    slider.classList.add("active");
    const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
    setStartX(x);
    setScrollLeft(slider.scrollLeft);
  };

  const move = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX || e.touches[0].pageX - sliderRef.current.offsetLeft;
    const dist = x - startX;
    sliderRef.current.scrollLeft = scrollLeft - dist;
  };

  const end = () => {
    setIsDown(false);
    sliderRef.current.classList.remove("active");
  };
  const handleKeyUp = (e) => {
    if (e.keyCode == 13 && e.shiftKey) {
      e.preventDefault();
      setFeedmsg((prevText) => prevText + "\n");
    } else if (e.keyCode == 13 && !e.shiftKey) {
      e.preventDefault();
      handelSubmit();
    }
  };

  const [messageIndex, setMessageIndex] = useState(0);
  const messages = [
    "Thinking....",
    "Searching through my knowledge base...",
    "Gathering the best resources...",
    "Crafting your response...",
  ];


  useEffect(() => {
    if (load && isLastItem && messageIndex < messages.length - 1) {
      const timer = setTimeout(() => {
        setMessageIndex((prev) => prev + 1);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [messageIndex, load, isLastItem]);

  const [shouldSubmit, setShouldSubmit] = useState(false);

  const handelButtonList = (item) => {
    handelClickButton(item);
    setShouldSubmit(true);
  };

  useEffect(() => {
    if (shouldSubmit && feedmsg) {
      handelSubmit();
      setShouldSubmit(false);
    }
  }, [feedmsg, shouldSubmit]);
  const slideShow = () => {
    setShowChat(true);
    setIsRendered(true);
    setChatbotOpen(prev => !prev);
    setAddClass(true);
    setSideExpand(prev => !prev);
    setShowSearch(false);
    setIsLeft(false)
  }

  const slideShowleft = () => {
    setShowChat(true);
    setIsRendered(true);
    setChatbotOpen(prev => !prev);
    setAddClass(true);
    setSideExpand(prev => !prev);
    setShowSearch(false);
    setIsLeft(true)
  }


  const chatContainer = document.getElementById("chat-container");
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "40px";
      textareaRef.current.style.height = `${Math.min(
        textareaRef.current.scrollHeight,
        80
      )}px`;
    }
  }, [feedmsg]);
  const bottomRef = useRef(null);

  // useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [chatList]);

  useEffect(() => {
    if (!showBack) {
      if (bottomRef.current) {
        bottomRef.current.scrollTop = bottomRef.current.scrollHeight;
      }
    }
  }, [chatList, showchat, visibleText, showChatHistory]);


  const onInfoClick = () => {
    setShowInfo(!showInfo)
  }

  const handleCopy = (index) => {
    const element = copyRef.current[index];
    if (element) {
      // const plainText = element.innerText;
      // navigator.clipboard.writeText(plainText);

      const plainText = element.innerText;
      const htmlText = element.innerHTML;

      const clipboardItem = new ClipboardItem({
        'text/plain': new Blob([plainText], { type: 'text/plain' }),
        'text/html': new Blob([htmlText], { type: 'text/html' })
      });

      navigator.clipboard.write([clipboardItem]);
      setCopyIndex(index);
      setCopy(true)
    }

    setTimeout(() => {
      setCopy(false)
      setCopyIndex(null)
    }, 1500);
  }

  const renderTooltip = (index, props) => (
    <Tooltip id={`tooltip-${index}`} {...props}
      style={{
        position: "absolute",
        top: "-30px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "black",
        color: "#fff",
        borderRadius: "5px",
      }}
    >
      {copyIndex === index ? 'Copied!' : 'Copy Response'}
    </Tooltip>
  );


  return (
    <div>
    {
      showChatboat && !isRendered && (
      <ChatbotSearch onClick={onClick}
        showChatboat={showChatboat}
        feedmsg={feedmsg}
        setFeedmsg={setFeedmsg}
        handelSubmit={handelSubmit}
        setChatbotOpen={setChatbotOpen}
        chatbotOpen={chatbotOpen} handleKeyUp={handleKeyUp}
        setShowSearch={setShowSearch}
        setSideExpand={setSideExpand}
        getChathistory={getChathistory}
        //getchat={GetChats}
        chathistory={GetHistory}
        chatNameheader={chatNameHeader}
        showSearch={showSearch}
        displayChatHistory={displayChatHistory}
        selectedOrg={selectedOrg}
        orgData={orgData}
        showchat={showchat}
      />
      )
    }
      {!isRendered ? (
        // <div
        //   className="chatbot_fixed d-flex align-items-center"
        //   hidden={showchat}
        //   onClick={onClick}
        // >
        //   <span>
        //     <img
        //       style={{ width: "32px", height: "32px", cursor: "pointer" }}
        //       src={kareem}
        //       alt=""
        //     />
        //   </span>
        //   <h2 className="ms-2 mb-0">Ask Claire</h2>
        // </div>
        <></>
      ) : (
        <>
          {chatbotOpen && (

            <div
              className="chatbot-overlay"
              style={{
                position: "fixed",
                top: "76px",
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.4)",
                zIndex: 1040
              }}
            />
          )}

          <div
            // className="chatbot-popup"
            className={`chatbot-popup ${showchat ? "show" : "hide"} 
           ${!chatbotOpen ? "sidechatbot" : "modalchatbot"}
      ${isLeft ? "left" : "right"} 
      ${isTogglingPosition ? (isLeft ? "slide-right" : "slide-left") : ""}`}
            id="chat-container"
          // ref={chatContainerRef}
          // hidden={!showchat}
          >
            {Loading && <Loader opacity={0.01} color='black' />}
            <div
              className="side-icon"
              style={{ cursor: "pointer" }}
              onClick={togglePosition}
            >
              {/* <img
                src={!chatbotOpen ? leftsemiCircle : ''}
                alt=""
                style={{ transform: isLeft ? "scaleX(-1)" : "" }}
              /> */}

            </div>
            <div className="chat-header">
              <div className="header-info">
                <div className="d-flex justify-content-center align-items-center infopara">
                  {/* <span>
                    <img src={KareemWhite} alt="Claire Icon" width="16px" />
                  </span> */}
                  <h2 className="logo-text ms-2">Claire</h2>
                  <OverlayTrigger
                    //  show={showInfo}
                    overlay={(props) => (
                      <Tooltip {...props} className="tooltipInfo">Please verify any responses before making critical decisions</Tooltip>
                    )}
                    placement="bottom"
                  >
                    <div className="ms-2 info" style={{ cursor: "pointer" }}
                    //onClick={onInfoClick}
                    >
                      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.5 0C8.0913 0 9.61742 0.632141 10.7426 1.75736C11.8679 2.88258 12.5 4.4087 12.5 6C12.5
                         7.5913 11.8679 9.11742 10.7426 10.2426C9.61742 11.3679 8.0913 12 6.5 12C4.9087 12 3.38258 11.3679
                          2.25736 10.2426C1.13214 9.11742 0.5 7.5913 0.5 6C0.5 4.4087 1.13214 2.88258 2.25736 1.75736C3.38258
                           0.632141 4.9087 0 6.5 0ZM6.5 4.5C6.58442 4.5 6.66802 4.48337 6.74601 4.45107C6.82401 4.41876 6.89487
                            4.37141 6.95457 4.31171C7.01426 4.25202 7.06162 4.18115 7.09392 4.10315C7.12623 4.02516 7.14286
                             3.94156 7.14286 3.85714C7.14286 3.77272 7.12623 3.68913 7.09392 3.61113C7.06162 3.53314 7.01426
                              3.46227 6.95457 3.40257C6.89487 3.34288 6.82401 3.29553 6.74601 3.26322C6.66802 3.23091 6.58442
                               3.21429 6.5 3.21429C6.32973 3.21429 6.16644 3.28192 6.04604 3.40232C5.92564 3.52272 5.858 3.68602
                                5.858 3.85629C5.858 4.02655 5.92564 4.18985 6.04604 4.31025C6.16644 4.43065 6.32973 4.49829
                                 6.5 4.49829M6.92857 5.56971C6.92857 5.45605 6.88342 5.34704 6.80305 5.26667C6.72267
                                  5.1863 6.61366 5.14114 6.5 5.14114C6.38634 5.14114 6.27733 5.1863 6.19695 5.26667C6.11658 
                                  5.34704 6.07143 5.45605 6.07143 5.56971V8.14114C6.07143 8.25481 6.11658 8.36382 6.19695 
                                  8.44419C6.27733 8.52456 6.38634 8.56971 6.5 8.56971C6.61366 8.56971 6.72267 8.52456 6.80305
                                   8.44419C6.88342 8.36382 6.92857 8.25481 6.92857 8.14114V5.56971Z" fill="#9E9E9E" />
                      </svg>
                    </div>
                    {/* <img className="ms-2" src={infoicon} alt="" style={{ cursor: "pointer" }} onClick={onInfoClick} /> */}
                  </OverlayTrigger>
                  {/* {
                    selectedOrg && (
                      <OverlayTrigger
                        overlay={(props) => (
                          <Tooltip {...props} className="tooltipInfo">{selectedOrg.organizationName}</Tooltip>
                        )}
                        placement="bottom"
                      >
                        <div className={`selected-orgname ${!chatbotOpen ? "side-select" : ""} `}>
                          <p>Organization: {selectedOrg.organizationName}</p>
                        </div>
                      </OverlayTrigger>
                    )
                  } */}
                  <div className="ps-3 ms-3 d-inline mx-1 mt-1 mb-0 top_kareem">
                    {orgData.length == 1 ?

                      <div>
                        {!chatbotOpen && orgData[0].organizationName.length > 8 ?
                          <OverlayTrigger overlay={(props) => (
                            <Tooltip {...props}>{orgData[0].organizationName}</Tooltip>
                          )}
                            placement="bottom">
                            <span className="ms-1 side-select"> {orgData[0].organizationName}</span>
                          </OverlayTrigger>
                          :
                          <span className="ms-1"> {orgData[0].organizationName}</span>}</div>
                      :
                      <div>
                        {!chatbotOpen && selectedOrg.organizationName.length > 8 ? <OverlayTrigger overlay={(props) => (
                          <Tooltip {...props}>{selectedOrg.organizationName}</Tooltip>
                        )}
                          placement="bottom">
                          <span className="ms-1 side-select">{selectedOrg.organizationName} </span>
                        </OverlayTrigger> : <span className="ms-1"> {selectedOrg.organizationName} </span>}</div>
                    }
                  </div>

                </div>
              </div>
              <div>
                {" "}
                {
                  chatbotOpen ? (
                    <>
                      <span onClick={slideShowleft} style={{ cursor: "pointer" }} >
                        <OverlayTrigger
                          overlay={(props) => (
                            <Tooltip {...props}>Slide to Left</Tooltip>
                          )}
                          placement="bottom"
                        >
                          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4.48387V13.5161C2 14.8868 3.09556 16 4.44444 16H11.5556C12.9044 16 14 14.8868 14 13.5161V4.48387C14 3.11323 12.9044 2 11.5556 2H4.44444C3.09556 2 2 3.11323 2 4.48387Z
           M11.5556 3.35484C12.1689 3.35484 12.6667 3.86065 12.6667 4.48387V13.5161C12.6667 14.1394 12.1689 14.6452 11.5556 14.6452H10V3.35484H11.5556Z
           M8.66667 3.35484V14.6452H4.44444C3.83111 14.6452 3.33333 14.1394 3.33333 13.5161V4.48387C3.33333 3.86065 3.83111 3.35484 4.44444 3.35484H8.66667Z"
                              fill="#702C62" transform="translate(18, 0) scale(-1, 1 )" />
                          </svg>
                        </OverlayTrigger>
                      </span>
                      <span className="ms-2" onClick={slideShow} style={{ cursor: "pointer" }}>
                        <OverlayTrigger
                          overlay={(props) => (
                            <Tooltip {...props}>Slide to Right</Tooltip>
                          )}
                          placement="bottom"
                        >
                          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4.48387V13.5161C2 14.8868 3.09556 16 4.44444 16H11.5556C12.9044 16 14 14.8868 14 13.5161V4.48387C14 3.11323 12.9044 2 11.5556 2H4.44444C3.09556 2 2 3.11323 2 4.48387Z
           M11.5556 3.35484C12.1689 3.35484 12.6667 3.86065 12.6667 4.48387V13.5161C12.6667 14.1394 12.1689 14.6452 11.5556 14.6452H10V3.35484H11.5556Z
           M8.66667 3.35484V14.6452H4.44444C3.83111 14.6452 3.33333 14.1394 3.33333 13.5161V4.48387C3.33333 3.86065 3.83111 3.35484 4.44444 3.35484H8.66667Z"
                              fill="#702C62" />
                          </svg>
                        </OverlayTrigger>
                      </span>
                    </>
                  ) : (<>
                    {
                      isLeft ?
                        <span onClick={togglePosition} style={{ cursor: "pointer" }}>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip {...props}>Slide to Right</Tooltip>
                            )}
                            placement="bottom"
                          >
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2 4.48387V13.5161C2 14.8868 3.09556 16 4.44444 16H11.5556C12.9044 16 14 14.8868 14 13.5161V4.48387C14 3.11323 12.9044 2 11.5556 2H4.44444C3.09556 2 2 3.11323 2 4.48387Z
         M11.5556 3.35484C12.1689 3.35484 12.6667 3.86065 12.6667 4.48387V13.5161C12.6667 14.1394 12.1689 14.6452 11.5556 14.6452H10V3.35484H11.5556Z
         M8.66667 3.35484V14.6452H4.44444C3.83111 14.6452 3.33333 14.1394 3.33333 13.5161V4.48387C3.33333 3.86065 3.83111 3.35484 4.44444 3.35484H8.66667Z"
                                fill="#702C62" />
                            </svg>
                          </OverlayTrigger>
                        </span>
                        :
                        <span onClick={togglePosition} className="ms-2" style={{ cursor: "pointer" }}>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip {...props}>Slide to Left</Tooltip>
                            )}
                            placement="bottom"
                          >
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2 4.48387V13.5161C2 14.8868 3.09556 16 4.44444 16H11.5556C12.9044 16 14 14.8868 14 13.5161V4.48387C14 3.11323 12.9044 2 11.5556 2H4.44444C3.09556 2 2 3.11323 2 4.48387Z
       M11.5556 3.35484C12.1689 3.35484 12.6667 3.86065 12.6667 4.48387V13.5161C12.6667 14.1394 12.1689 14.6452 11.5556 14.6452H10V3.35484H11.5556Z
       M8.66667 3.35484V14.6452H4.44444C3.83111 14.6452 3.33333 14.1394 3.33333 13.5161V4.48387C3.33333 3.86065 3.83111 3.35484 4.44444 3.35484H8.66667Z"
                                fill="#702C62" transform="translate(18, 0) scale(-1, 1 )" />
                            </svg>
                          </OverlayTrigger>
                        </span>


                    }
                    <span onClick={isLeft ? slideShowleft : slideShow} style={{ cursor: "pointer" }} className="ms-2">
                      <OverlayTrigger
                        overlay={(props) => (
                          <Tooltip {...props}>Expand</Tooltip>
                        )}
                        placement="bottom"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 2H14V6" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M6 14H2V10" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13.99987 2L9.33203 6.66667" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M2 13.9997L6.66667 9.33301" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </OverlayTrigger>
                    </span>
                  </>
                  )
                }
                <span className="ms-2" onClick={onClick} style={{ cursor: "pointer" }}>
                  {/* <img
                    style={{ cursor: "pointer" }}
                    src={closepurple}
                    alt=""
                    onClick={onClick}
                  /> */}
                  <OverlayTrigger
                    overlay={(props) => (
                      <Tooltip {...props}>Close</Tooltip>
                    )}
                    placement="bottom"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 4L4 12" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4 4L12 12" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </OverlayTrigger>
                </span>

              </div>
            </div>
            {/* <div className="d-flex justify-content-between align-items-center back-info">
              <div className="d-flex align-items-center">
                <span onClick={() => ShowChatHistoryList(chatNameHeader)}>
                  <img
                    style={{ cursor: "pointer" }}
                    hidden={showBack}
                    src={leftarrow}
                    alt=""
                  />
                </span>
                <p className="mb-0 ms-2" style={{ color: "#702c62" }}> */}
            {/* {shownewChat == true
                ? "New Chat"
                : Chatname
                ? Chatname
                : "New Treads"} */}
            {/* {Chatname ? Chatname : showBack ? "Chat History" : "New Chat"} */}
            {/* {Chatname?Chatname:"NewChat"?showBack?"New Treads":""} */}
            {/* </p>
              </div>
              <div> */}
            {/* <span onClick={ShowNewChat}>
                  <img style={{ cursor: "pointer" }} src={newicon} alt="" />
                </span>
              </div>
            </div> */}
            <div
              ref={bottomRef}
              className={`chat-body border-top ${showBack ? "chathistory" : ""}`}
            // id="bottomRef"
            >
              <div>
                {shownewChat == true ? (
                  <div>
                    <div className="bot d-flex">
                      <div className="message bot-message d-flex">
                        <img src={clairebot} alt="" />

                        {/* <p>Kareem</p> */}
                      </div>

                      <div className="message-text">
                        <p>
                          Hi, I'm Claire! I can assist you in pulling data, delivering insights and recommending next best actions for maintaining and improving your 340B contract pharmacy program. I can also help guide you through any tasks you want to perform in the application and troubleshoot any issues you may be having. Whether it's anything from assessing your 340B inventory, visualizing your trending savings/capture rates to monitoring compliance risk for any of your covered entities, I'm here to help!
                        </p>
                        {/*<p>
                          Hi, I'm Claire! I can help guide you on all things
                          related to your Contract Pharmacy 2.0 application.
                          Whether you have a general question about how the
                          product works or would like to know how to perform a
                          specific task in the app, I'm here to help!
                        </p>*/}
                      </div>
                    </div>

                    <div>
                      { }
                      <div
                        className="starred-question my-2"
                        style={{ textAlign: "right" }}
                      >
                        {buttonnames.map((item) => {
                          return (
                            <div>
                              <button
                                key={item.id}
                                onClick={() => handelButtonList(item.name)}
                                type="button"
                                class="reset btn btn-primary mb-2 "
                                style={{ fontSize: "12px" }}
                              >
                                {item.name}
                              </button>
                            </div>

                          );
                        })}

                        {/* <span className="mb-0 or-line">or</span>
                    <small>
                      you can type your message below and i’ll do anything i
                      can to assist you
                    </small> */}
                      </div>

                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {showBack && (
                <div>
                  {getChathistory.map((item) => {
                    return (
                      <div
                        className=""
                      // style={{ padding: "0px" }}
                      >
                        <>
                          <p className="date-list mb-0">
                            <span>{item.date}</span>
                          </p>
                          {item?.chat_names?.map((item1) => {
                            //  date=item?.chat_time
                            // let timezone = convertToBrowserTimezoneTime(
                            //   item1?.chat_time
                            // );

                            // let date = new Date(item1?.chat_time);
                            // let datevalue = date.toISOString().slice(11, 16);
                            let datevalue = moment(item1?.chat_time).format("LT");

                            return (
                              <div
                                className="d-flex justify-content-between align-items-center chat-history"
                                onClick={() => {
                                  ShowChatHistoryDetails(item1.name);
                                }}
                              >
                                <h4 style={{ cursor: "pointer" }}>
                                  {item1?.name}
                                </h4>
                                <p>{datevalue}</p>
                                {/* <p>{item1.message}</p> */}
                              </div>
                            );
                          })}
                        </>
                      </div>
                    );
                  })}
                </div>
              )}
              {showChatHistory && (
                <div>
                  {chatList?.map((item, index) => {
                    isLastItem = index === chatList.length - 1;
                    var fedanswer = "";
                    var fedquestion = "";
                    return (
                      <>
                        <p className="date-format text-center">{item?.date}</p>
                        {item.history?.map((item1, index) => {
                          const previousItem = index > 0 ? item.history[index - 1] : null;
                          fedanswer = item1.message;
                          fedquestion = previousItem?.message
                          let datetype =
                            item1?.msg_time == "Today" ? "Today" : "";
                          if (datetype != "Today") {
                            // var date = new Date(item1?.msg_time);
                            // var datevalue = date?.toISOString()?.slice(11, 16);
                            var datevalue = moment(item1?.msg_time).format("LT");
                          }

                          return (
                            <>
                              <div className={`${item1.isAgent ? "user" : "bot"} ${chatbotOpen ? "d-flex" : "slideuserposition"}`} >
                                <div
                                  className={
                                    item1.isAgent
                                      ? "message user-message d-flex align-items-start mb-2"
                                      : "message bot-message d-flex align-items-start mb-2"
                                  }
                                >
                                  <img
                                    className=""
                                    src={item1?.isAgent ? usericon : clairebot}
                                    alt=""
                                  />
                                  {/* <p>{item1.isAgent ? "You" : "Claire"}</p> */}
                                </div>
                                <div className="message-text flex-row-reverse" ref={(el) => (copyRef.current[index] = el)} >
                                  {/* <p
                                  dangerouslySetInnerHTML={{
                                    __html: item1.message,
                                  }}
                                ></p> */}
                                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {item1.message}
                                  </ReactMarkdown>
                                </div>
                                <div className="mb-0">
                                  {/* <div className="time_info d-flex flex-row-reverse">
                                    <p> {item1.isAgent ? item1.usermsg_date : ""}</p>
                                  </div> */}
                                </div>
                                {/* <div className="time_info d-flex flex-row-reverse">
                                  <p> {item1.isAgent ? datevalue : ""}</p>
                                </div> */}
                              </div >

                              {!item1.isAgent && item1.isRes === true && (
                                <>
                                  <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                                    <div className={`feedback_icon ${chatbotOpen ? "feedmargin" : ""}`}>
                                      <small >
                                        <OverlayTrigger
                                          flip={false}
                                          overlay={renderTooltip(index)}
                                          placement="bottom"
                                          delay={{ show: 100, hide: 100 }}
                                          //trigger="click"

                                          trigger={['hover', 'click']}
                                        //show={copyIndex === index ? true : undefined}
                                        >
                                          <span onClick={() => handleCopy(index)}
                                            style={{


                                              width: '18px',
                                              height: '18px',
                                              display: 'inline-block',
                                              overflow: 'hidden',
                                              verticalAlign: 'middle',
                                              position: 'relative',
                                            }}
                                          >
                                            {copy && copyIndex === index ?
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                <g clip-path="url(#clip0_1609_38141)">
                                                  <path d="M14.6668 7.38723V8.00056C14.666 9.43818 14.2005 10.837 13.3397 11.9884C12.4789 13.1399 11.269 13.9822 9.8904 14.3898C8.51178 14.7974 7.03834 14.7485 5.68981 14.2503C4.34128 13.7521 3.18993 12.8313 2.40747 11.6253C1.62501 10.4193 1.25336 8.9926 1.34795 7.5581C1.44254 6.1236 1.9983 4.75811 2.93235 3.66528C3.8664 2.57244 5.12869 1.81082 6.53096 1.49399C7.93323 1.17717 9.40034 1.32212 10.7135 1.90723" stroke="#FEFEFE" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                  <path d="M14.6667 2.66602L8 9.33935L6 7.33935" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_1609_38141">
                                                    <rect width="18" height="18" fill="white" />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                              :
                                              <img
                                                width={18} height={18}
                                                src={copyIcon}
                                                alt=""
                                              // onMouseLeave={() => { setCopyIndex(null) }}
                                              />
                                            }

                                          </span>



                                        </OverlayTrigger>

                                      </small>
                                      <small className="ms-2">
                                        <img
                                          onClick={() => {
                                            handleUpDownClick(
                                              item1.message,
                                              "Y",
                                              previousItem?.message
                                            );
                                          }}
                                          src={thumbsup}
                                          alt=""
                                        />
                                      </small>
                                      <small className="ms-2">
                                        <img
                                          onClick={() =>
                                            handleDownClickdata(
                                              item1.message,
                                              "N",
                                              previousItem?.message,
                                              index
                                            )
                                          }
                                          src={thumbsdown}
                                          alt=""
                                        />
                                      </small>
                                    </div>
                                    <div className="time_info ">
                                      {/* <p>{datetype ? datetype : datevalue}</p> */}

                                    </div>


                                  </div>
                                  <div>

                                    <div className="model_thumbs_down">
                                      <div className="lg thumbs_down">
                                        {handleDownClickcontent && feeddown == index && (
                                          <div className="handledown_info">
                                            {/* <p>{feedmsg}</p> */}
                                            <div className="textarea_info">
                                              <Input
                                                type="textarea"
                                                //  style={lines >0?{height:lines}:{height:40}}
                                                class="w-100"
                                                value={reportmesg}
                                                onChange={(event) =>
                                                  handelClickReport(event)
                                                }
                                                placeholder="Type feedback here..."
                                              />

                                              <button
                                                style={{
                                                  background: "transparent",
                                                  border: "none",
                                                }}
                                                onClick={handleCancel}
                                                type="text"
                                              >
                                                <img src={closepurple} alt="" />
                                              </button>
                                              {/* <textarea type="text" class="form-control" value={feedmsg} 
                                       onChange={(event)=>handelMessage(event)}placeholder='Tell us what went wrong...'/> */}
                                            </div>
                                            <div className="handledown_info_btn">
                                              <div className="btns_list">
                                                <ul
                                                  ref={sliderRef}
                                                  className="items"
                                                  onMouseDown={start}
                                                  onTouchStart={start}
                                                  onMouseMove={move}
                                                  onTouchMove={move}
                                                  onMouseLeave={end}
                                                  onMouseUp={end}
                                                  onTouchEnd={end}
                                                >
                                                  {displaybuttons.map((item, index) => {
                                                    return (
                                                      // <Button key={item.id} onClick={()=>handelDisplay(item.name)}>
                                                      //     {item.name}
                                                      // </Button>

                                                      <Button
                                                        key={item.id}
                                                        onClick={() =>
                                                          handelDisplay(item.name, item.id)
                                                        }
                                                        className={`item ${selectedButtons.includes(item.id)
                                                          ? "active-button"
                                                          : ""
                                                          }`}
                                                      >
                                                        {item.name}
                                                      </Button>
                                                    );
                                                  })}
                                                </ul>
                                              </div>

                                              <div className="sub_btn">
                                                <Button
                                                  onClick={() => {
                                                    handleUpDownClick(
                                                      item1.message,
                                                      "N",
                                                      previousItem?.message,
                                                    ),
                                                      handleDownClick();
                                                  }}
                                                >
                                                  <span className="right_5">
                                                    <img src={uparrow} alt="" />
                                                  </span>{" "}
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                  </div>

                                </>


                              )
                              }
                              <div>

                              </div>
                            </>
                          );
                        })}

                        {/* <div className="model_thumbs_down">
                      <div className="lg thumbs_down">
                        <div className="handledown_info">
                          <div className="textarea_info">
                            <textarea
                              placeholder="Tell us what went wrong..."
                              class="w-100 form-control"
                              style={{ height: "40px" }}
                            ></textarea>
                            <button
                              type="text"
                              style={{
                                background: "transparent",
                                border: "none",
                              }}
                            >
                              <img
                                onClick={onClick2}
                                src={closepurple}
                                alt=""
                              />
                            </button>
                          </div>
                          <div className="handledown_info_btn">
                            <div class="btns_list">
                              <ul class="items">
                                <button
                                  type="button"
                                  class="item active-button btn btn-secondary"
                                >
                                  Irrelevant
                                </button>
                                <button
                                  type="button"
                                  class="item  btn btn-secondary"
                                >
                                  Not Factually correct
                                </button>
                                <button
                                  type="button"
                                  class="item  btn btn-secondary"
                                >
                                  Incomplete response
                                </button>
                              </ul>
                            </div>
                            <div className="sub_btn">
                              <Button type="submit" class="btn btn-primary">
                                <img src={uparrow} alt="" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                        {load && (
                          <div className="bot-loader message bot-message d-flex align-items-center">
                            <span>
                              <img src={clairebot} alt="" />
                            </span>
                            <div className="md-16">
                              <div className="snippet message-text">
                                <div className="stage">
                                  <div className="dot-animation">
                                    <div className="bounce1" style={{ marginRight: "2px" }}></div>
                                    <div className="bounce2" style={{ marginRight: "2px" }}></div>
                                    <div className="bounce3" style={{ marginRight: "0px" }}></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}


                      </>
                    );
                  })}
                </div>
              )}
            </div>

            {showInput == true && (
              <div className="chat-footer">
                <form className="chat-footer-inner">
                  <div class=" input-group">
                    <InputGroup>
                      <Input type="text"
                        // ref={textareaRef}
                        class="form-control message-test"
                        onChange={(event) => handelClick(event)}
                        onKeyDown={handleKeyUp}
                        // maxLength={500}
                        minLength={1}
                        value={feedmsg}
                        style={{ height: "40px", borderRight: "none" }}
                        placeholder="Type your message here....." />
                      <InputGroupText>
                        <img src={Send} alt="Send"
                          // className="send-icon"
                          onClick={handelSubmit}
                          style={feedmsg.length > 0 ? { cursor: "pointer" } : { cursor: "not-allowed" }}
                        />
                        {/* <span onClick={handelSubmit} style={{ cursor: "pointer" }} className="send-icon">
                          
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6 12L10 8L6 4" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span> */}
                      </InputGroupText>
                    </InputGroup>
                    {/* <Input
                    // type="textarea"
                    ref={textareaRef}
                    class="form-control message-test"
                    onChange={(event) => handelClick(event)}
                    onKeyDown={handleKeyUp}
                    maxLength={500}
                    minLength={1}
                    value={feedmsg}
                    style={{ height: `${height}px` }}
                    placeholder="Type your message here....."
                  /> */}
                    {/* <Button class="btn btn-primary" onClick={handelSubmit}>
                    <img src={uparrow} alt="" />
                  </Button> */}
                  </div>
                </form>
              </div>
            )}
            {showBack == true && (
              <div className="chat-footer">
                <form className="chat-footer-inner">
                  <div class="chat-form form-group">
                    {/* <Input
                  type="textarea"
                  class="form-control message-test"
                  onChange={(event) => handelClick(event)}
                  onKeyDown={(e) => handleKeyUp(e)}
                  maxLength={500}
                  minLength={1}
                  value={feedmsg}
                  placeholder="Type your message here....."
                />
                <Button class="btn btn-primary" onClick={handelSubmit}>
                  <img src={uparrow} alt="" />
                </Button> */}
                  </div>
                </form>
                {/* <div className="d-flex justify-content-center align-items-center infopara">
                  <img src={infoicon} alt="" />
                  <p className="ms-1">
                    Please verify any responses before making critical decisions
                  </p>
                </div> */}
              </div>
            )}
          </div>
        </>

      )
      }
    </div >
  );
};

export default ChatBotPage;
